<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null">
        <v-parallax src="/static/images/abroad-card.jpg" height="100">
          <v-layout align-center column justify-center>
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">관세청</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center"
            >{{ model.baseInfo.prgsStts }}</h4>
          </v-layout>
        </v-parallax>

        <v-container id="grid" fluid grid-list-sm tag="section" class="test">
          <v-flex mb-2>
            <span class="title">{{ model.baseInfo.prnm }}</span>
          </v-flex>
          <v-layout wrap>
            <v-flex xs4 lg4 md4 sm4 xs6 pl-2 pr-2>
              <label-text title="적재항" :text="model.baseInfo.loadPortAirptCd"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs4 lg4 md4 sm4 xs6 pl-2 pr-2>
              <LabelText title="양륙항" :text="model.baseInfo.unldPortAirptCd"></LabelText>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs4 lg4 md4 sm4 xs6 pl-2 pr-2>
              <label-text title="입항일" :text="model.baseInfo.etprDt"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs4 lg4 md4 sm4 xs6 pl-2 pr-2>
              <label-text title="통관진행상태" :text="model.baseInfo.prgsStts"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs2 lg2 md2 sm2 xs6 pl-2 pr-2>
              <label-text title="수량" :text="model.baseInfo.cmdtGcnt + ' ' + model.baseInfo.pckKcd"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs2 lg2 md2 sm2 xs6 pl-2 pr-2>
              <label-text title="중량" :text="model.baseInfo.cmdtWght + ' ' + model.baseInfo.kg"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs2 lg2 md2 sm2 xs6 pl-2>
              <label-text title="선사/항공사" :text="model.baseInfo.shcoFlcoSgn"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs2 lg2 md2 sm2 xs6 pr-2>
              <v-flex class="gray-caption">편명</v-flex>
              <v-btn
                small
                style="margin:0px; padding:0px;"
                slot="activator"
                color="red lighten-2"
                dark
                @click="openDialog"
              >
                <v-flex class="body-2 text-xs-center">
                  <span v-html="model.baseInfo.sanm"></span>
                </v-flex>
              </v-btn>
              <div >
                <v-dialog v-model="dialog2" width="80%" @input="v => v || closeDialog()">
                <v-layout column class="text-xs-center"
                          >

                  <v-card>
                    <v-card-text>
                      <v-btn
                        v-show="!isAir"
                        class="text-capitalize"
                        color="secondary"
                        dark
                        @click="goTracking('marineTraffic', model.baseInfo.mmsi)"
                      >MarineTraffic</v-btn>
                      <v-btn
                        v-show="!isAir"
                        class="text-capitalize"
                        color="secondary"
                        dark
                        @click="goTracking('myShipTracking', model.baseInfo.mmsi)"
                      >MyShipTracking</v-btn>
                      <v-btn
                        v-show="isAir"
                        class="text-capitalize"
                        color="secondary"
                        dark
                        @click="goTracking('radarBox', model.baseInfo.sanm)"
                      >AirNav-RadarBox</v-btn>
                      <v-btn
                        v-show="isAir"
                        class="text-capitalize"
                        color="secondary"
                        dark
                        @click="goTracking('flightRadar', model.baseInfo.sanm)"
                      >FlightRadar24</v-btn>
                      <v-btn
                        v-show="isAir"
                        class="text-capitalize"
                        color="secondary"
                        dark
                        @click="goTracking('flightAware', model.baseInfo.sanm)"
                      >FlightAware</v-btn>
                    </v-card-text>
                  </v-card>
                </v-layout>
                </v-dialog>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-container v-if="!hasResult" fill-height fluid>
          <v-layout column class="text-xs-center">
            <v-flex>
              <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
            </v-flex>
          </v-layout>
        </v-container>

        <v-flex>
          <template v-for="(item, index) in model.list">
            <delivery-list-item v-bind:key="index"
              v-bind:title="item.cargTrcnRelaBsopTpcd"
              v-bind:primary-chip="item.snarKoreNm"
              v-bind:green-chip="item.brngBssNo == '' ? '' : '신고번호:'+item.brngBssNo"
              v-bind:date="[ item.prcsDttm, 'YYYYMMDDHHmmss' ] | moment('YYYY.MM.DD HH:mm:ss')"
            ></delivery-list-item>
            <v-divider v-if="index + 1 < model.list.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'

export default {
  name: 'AbroadDeliveryCard',
  components: { LabelText, DeliveryListItem },
  props: ['model'],
  data () {
    return {
      dialog2: false
    }
  },
  computed: {
    isAir: function () {
      // return true
      return (this.model.baseInfo.mmsi === '' || this.model.baseInfo.mmsi === null)
    },
    hasResult: function () {
      return this.model.list.length > 0
    }
  },
  methods: {
    closeDialog: function () {
      this.dialog2 = false
    },
    openDialog: function () {
      this.dialog2 = true
    },
    goTracking: function (target, name) {
      if (target === 'flightAware') {
        window.open('https://flightaware.com/live/flight/' + name, '_blank')
      } else if (target === 'flightRadar') {
        window.open(
          'https://www.flightradar24.com/data/flights/' + name.toLowerCase(),
          '_blank'
        )
      } else if (target === 'radarBox') {
        window.open(
          'https://www.radarbox24.com/data/flights/' + name,
          '_blank'
        )
      } else if (target === 'marineTraffic') {
        window.open(
          'https://www.marinetraffic.com/en/ais/details/ships/mmsi:' + name,
          '_blank'
        )
      } else if (target === 'myShipTracking') {
        window.open(
          'https://www.myshiptracking.com/?mmsi=' + name,
          '_blank'
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/AbroadDeliveryCard.vue